import React from "react";
// import { bindActionCreators } from "redux"
// import { connect } from "react-redux"
// import bind from "memoize-bind"

import CSSModules from "lib/utils/css-modules";
// import { rejectOrderWithConfirm, approveOrderWithConfirm } from "modules/customers/utils"
import CustomersListItem from "./CustomersListItem";
import styles from "./List.less";

// @connect(
//   state => ({
//     customerActionPendingById: state.customers.utils.customerActionPendingById,
//   }),
//   dispatch => bindActionCreators({
//     rejectOrderWithConfirm,
//     approveOrderWithConfirm,
//   }, dispatch)
// )
@CSSModules(styles)
export default class CustomersList extends React.PureComponent {
  render() {
    const { customers, ...rest } = this.props;
    return (
      <div styleName="list">
        {customers.map((customer) => (
          <CustomersListItem key={customer.id} customer={customer} {...rest} />
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/list/CustomersList.jsx